import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import FormCreator from './FormCreator';
import { IRegistrationFormField } from '../../types/global/forms.types';
import withDesktopOnly from '../../hoc/withDesktopOnly';
import { theme } from '../../constants/theme';
import { FONT_ENUM } from '../../types/global/fonts.types';
import { useThemeContext } from '../../hook/useThemeManager';

interface FormCreatorModalProps {
    open: boolean;
    onClose: () => void;
    initialFields?: IRegistrationFormField[];
    onSave?: (formFields: IRegistrationFormField[]) => void;
    title?: string;
}

const FormCreatorModal: React.FC<FormCreatorModalProps> = ({
    open,
    onClose,
    initialFields = [],
    onSave,
    title = 'Form Creator',
}) => {
    const { themeStyle } = useThemeContext();
    const [fields, setFields] = useState<IRegistrationFormField[]>(initialFields);

    const handleChange = (updatedFields: IRegistrationFormField[]) => {
        setFields(updatedFields);
    };

    const handleSave = (formFields: IRegistrationFormField[]) => {
        if (onSave) {
            onSave(formFields);
        }
        onClose();
    };

    console.log('should open', open);

    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
            maxWidth="md"
            PaperProps={{
                style: {
                    backgroundColor: theme[themeStyle].form_background,
                    borderRadius: 8,
                    height: '90vh',
                },
            }}>
            <DialogTitle
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    fontFamily: FONT_ENUM.MAIN_BOLD,
                    color: theme[themeStyle].primary_white,
                    bgcolor: theme[themeStyle].form_background,
                    padding: 2,
                }}>
                {title}
                <IconButton onClick={onClose} sx={{ color: theme[themeStyle].primary_white }}>
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent
                sx={{
                    padding: 0,
                    height: 'calc(90vh - 64px)', // Account for title height
                    overflow: 'hidden',
                }}>
                <FormCreator initialFields={fields} onChange={handleChange} onSave={handleSave} />
            </DialogContent>
        </Dialog>
    );
};

export default withDesktopOnly(FormCreatorModal);
